import React, { useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const QRPreview = ({ qrData, size, foregroundColor, backgroundColor }) => {
  const canvasRef = useRef(null);

  const generateQRCodeDataURL = () => {
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(qrData)}&color=${foregroundColor?.replace('#', '')}&bgcolor=${backgroundColor?.replace('#', '')}`;
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Icon name="Eye" size={18} color="var(--color-accent)" strokeWidth={2} />
        <h3 className="text-base font-heading font-semibold text-foreground">
          Live Preview
        </h3>
      </div>
      <div className="bg-card rounded-xl border border-border p-6 lg:p-8">
        <div className="flex items-center justify-center min-h-[300px] lg:min-h-[400px]">
          {qrData ? (
            <div className="relative">
              <div className="p-4 bg-background rounded-lg shadow-warm-lg">
                <Image
                  ref={canvasRef}
                  src={generateQRCodeDataURL()}
                  alt={`QR code containing: ${qrData?.substring(0, 50)}${qrData?.length > 50 ? '...' : ''}`}
                  className="w-full h-auto"
                  style={{ maxWidth: `${size}px`, maxHeight: `${size}px` }}
                />
              </div>
              <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-success flex items-center justify-center shadow-warm-md">
                <Icon name="Check" size={16} color="var(--color-success-foreground)" strokeWidth={3} />
              </div>
            </div>
          ) : (
            <div className="text-center space-y-3">
              <div className="w-20 h-20 mx-auto rounded-full bg-muted/50 flex items-center justify-center">
                <Icon name="QrCode" size={40} color="var(--color-muted-foreground)" strokeWidth={1.5} />
              </div>
              <div>
                <p className="text-sm font-caption font-medium text-muted-foreground">
                  No content yet
                </p>
                <p className="text-xs font-caption text-muted-foreground mt-1">
                  Enter content to generate QR code
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      {qrData && (
        <div className="flex items-start gap-2 p-3 rounded-lg bg-accent/5 border border-accent/20">
          <Icon name="Sparkles" size={16} color="var(--color-accent)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
          <p className="text-xs font-caption text-foreground leading-relaxed">
            Your QR code is ready! Test it with your phone's camera before sharing or printing.
          </p>
        </div>
      )}
    </div>
  );
};

export default QRPreview;